const ActionsCell = ({ children }) => {
	return <div className='v__table__body__row__cell__actions-list'>{children}</div>;
};

export default ActionsCell;
